import React from 'react';
import RadioMenuItem from './radioMenuItem';
import KeyModifierConstants from 'shared/constants/KeyModifierConstants.jsx';
import { isMac } from 'shared/lib/platformCheck';

/* eslint-disable react/prop-types */

const isMacPlatform = isMac();

const WidthMenuItem = ({ keyModifier, currentWidth, width, label }) => {
  let keyModNode = null;
  if (keyModifier) {
    let command = isMacPlatform
      ? KeyModifierConstants.macKeys[keyModifier]
      : KeyModifierConstants.windowsKeys[keyModifier];

    keyModNode = <span className="shortcut-key-modifier">{command}</span>;
  }

  const labelNode = (
    <span data-testid={`column-width-menu-${label}`}>
      {`Set ${label}`} {keyModNode}
    </span>
  );

  return <RadioMenuItem checked={currentWidth === width} label={labelNode} />;
};

export default WidthMenuItem;
